import { useQuery } from "@tanstack/react-query"
import { PartyPopperIcon, RefreshCwIcon } from "lucide-react"
import { useEffect, useState } from "react"

import { Button } from "@repo/ui/components/ui/button"
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@repo/ui/components/ui/dialog"
import { logger } from "@repo/utils/logger"
import { sharedConfig } from "~/lib/config/shared"
import { getVersionQueryOptions } from "~/lib/queries/version"

const log = logger.child({ module: "version-check" })

export function VersionCheck() {
  const [isOpen, setIsOpen] = useState(false)

  const { data: serverVersionData } = useQuery(getVersionQueryOptions())

  const serverVersion = serverVersionData?.version

  useEffect(() => {
    const versionsDiffer =
      serverVersion !== undefined && serverVersion !== sharedConfig.appVersion

    if (versionsDiffer) {
      log.info("Version check", {
        clientVersion: sharedConfig.appVersion,
        serverVersion,
      })
    }

    setIsOpen(versionsDiffer)
  }, [serverVersion])

  const handleUpdate = () => {
    window.location.reload()
  }

  const handleClose = () => {
    setIsOpen(false)
  }

  if (!sharedConfig.flags.versionCheckEnabled) {
    return null
  }

  return (
    <Dialog open={isOpen} onOpenChange={setIsOpen}>
      <DialogContent
        className="h-auto min-h-auto max-w-auto sm:max-w-md lg:min-w-auto"
        centered
      >
        <DialogHeader className="text-center sm:text-left" canClose={false}>
          <DialogTitle className="flex items-center justify-start text-xl">
            <PartyPopperIcon className="mr-2 size-5" />{" "}
            <span>New Version Available</span>
          </DialogTitle>
          <DialogDescription className="mt-2 text-base">
            We've released an update with new features and improvements. Refresh
            your browser to get the latest version.
          </DialogDescription>
        </DialogHeader>
        <DialogFooter className="flex-col gap-2 sm:flex-row">
          <Button
            variant="outline"
            onClick={handleClose}
            className="w-full sm:w-auto"
          >
            Not Now
          </Button>
          <Button
            onClick={handleUpdate}
            className="w-full sm:w-auto"
            aria-label="Refresh page to update application"
          >
            <RefreshCwIcon className="mr-2 size-4" />
            Refresh Now
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
